class PostfixDirective {

    constructor($filter, $parse) {
        this.restrict = 'A';
        this.require = 'ngModel';
        this.$filter = $filter;
        this.$parse = $parse;
    }

    link(scope, element, attrs, ngModelController) {

        const postfix = attrs.postfix;
        let isFocused = false;

        ngModelController.$parsers.push(function (data) {
            return parseInt(data);
        });

        ngModelController.$formatters.push(function (data) {
            if(isFocused) {
                return data;
            }
            return data.toString() + ' ' + postfix;
        });

        element.bind('focus', function () {
            isFocused = true;
            element.val(ngModelController.$modelValue);
        });

        element.bind('blur', function () {
            isFocused = false;
            element.val(parseInt(ngModelController.$viewValue).toString() + ' ' + postfix);
        });
    }

    static directiveFactory($filter, $parse) {
        'ngInject';
        return new PostfixDirective($filter, $parse);
    }

}

export default PostfixDirective;
